<template>
    <v-card>
        <v-btn text :to="'/search?g='+term" id="formSearch">
            test btn
        </v-btn>
        <v-navigation-drawer
                v-if="$vuetify.breakpoint.smAndDown"
                v-model="drawer"
                :clipped="$vuetify.breakpoint.xlOnly"
                app
                class="d-flex d-sm-none"
        >
            <v-list>
                <template v-for="(item,index) in items.categories">
                    <v-list-item
                            :key="index"
                            :to="'/'+item.meta_url"
                    >
                        <v-list-item-content>
                            <v-list-item-title>{{ item.menu_name }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                app
                :extension-height="60"
                fixed
                color="white"
        >
            <v-toolbar-title >
                <v-btn text :to="'/'" x-large>
                    <img src="../assets/img/logo.png" style="width: 185px;">
                </v-btn>

            </v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-text-field
                    :loading="loading.search"
                    flat
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    :append-icon="searchBtn ? 'mdi-send' : ''"
                    label="Search..."
                    class="hidden-sm-and-down"
                    v-model="term"
                    @click:append="getSearch"
                    v-on:keyup.enter="getSearch"
            ></v-text-field>
            <div class="flex-grow-1"></div>
            <template>
                <v-btn text v-if="$vuetify.breakpoint.smAndUp"><v-icon>mdi-phone</v-icon>1877-400-1700</v-btn>
                <v-btn icon :to="'/account'">
                    <v-icon>mdi-account</v-icon>
                </v-btn>
                <v-menu
                        :close-on-content-click="false"
                        :value="cartVisible"
                        bottom
                        transition="slide-y-transition"
                        min-width="350px"
                >
                    <template v-slot:activator="{ on }">
                        <v-btn
                                icon
                                v-on="on"
                                color="orange"
                        >
                            <v-badge
                                    color="orange"
                                    left
                                    v-model="showQtyCart"
                            >
                                <template v-slot:badge>
                                    <span>{{qtyCart}}</span>
                                </template>
                                <v-icon
                                >mdi-cart-outline</v-icon>
                            </v-badge>
                        </v-btn>
                    </template>
                    <v-list v-if="qtyCart == 0">
                        <v-list-item v-if="qtyCart == 0">
                            <v-list-item-title>Cart is empty</v-list-item-title>
                        </v-list-item>
                    </v-list>
                    <v-list v-else-if="cartPage == false" style="max-height: 600px; overflow: auto">
                        <v-subheader
                                v-text="'Cart'"
                        ></v-subheader>
                        <v-divider></v-divider>
                        <template v-for="(item, index) in cart.products">
                            <v-list-item :key="index">
                                <v-list-item-avatar>
                                    <v-img :src="cdnUrl+'/products/'+item.image"></v-img>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ item.product_en }}<br><span class="grey--text text--lighten-1">${{ item.value | number_format_real }}</span>
                                        <v-btn icon class="float-right" @click="deleteProductCart(index)" :loading="loading.cart">
                                            <v-icon color="red" >mdi-delete</v-icon>
                                        </v-btn>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        <v-text-field v-model="item.qty" @change="updateProductCart(index,'manual')" @keyup="updateProductCart(index,'manual')">
                                            <v-icon slot="append" color="red" @click="updateProductCart(index,'add')">mdi-plus</v-icon>
                                            <v-icon slot="prepend" color="green" @click="updateProductCart(index,'remove')">mdi-minus</v-icon>
                                        </v-text-field>
                                        Qty: {{ item.qty }}
                                        - Total: ${{ item.value*item.qty | number_format_real }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider :key="index+'a'"></v-divider>
                        </template>
                        <p class="font-weight-bold mb-6 text-center display-1 success">Total ${{ cart.total | number_format_real}}</p>
                        <v-btn
                                color="orange"
                                block
                                class="mt-5"
                                :to="'/cart'"
                        >
                            Checkout
                        </v-btn>
                    </v-list>
                </v-menu>
            </template>
            <template v-slot:extension >
                <v-text-field
                        clearable
                        flat
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        label="Search..."
                        v-if="search"
                        class="d-flex d-md-none"
                        v-model="term"
                        @keyup="getSearch"
                ></v-text-field>
                <v-tabs
                        :grow="true"
                        align-with-title
                        background-color="#06d6cf"
                        color="white"
                        v-if="search == false"
                >
                    <v-tabs-slider color="blue"></v-tabs-slider>
                    <v-tab class="d-flex d-sm-none" style="margin-left: 0 !important;justify-content: left;">
                        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
                    </v-tab>
                    <v-tab v-for="(item,index) in items.categories" :key="index" :to="'/'+item.meta_url" color="white" class="d-none d-sm-flex">
                        {{ item.menu_name }}
                    </v-tab>
                    <v-tab color="white" class="d-flex d-sm-none" @click="searchBar" style="   margin-left: 150px;">
                        <v-btn icon>
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                    </v-tab>
                </v-tabs>
            </template>
        </v-app-bar>
        <v-main>
            <v-fade-transition mode="out-in">
                <router-view
                        :cart="cart"
                        :appUrl="appUrl"
                        :cdnUrl="cdnUrl"
                        :categoriesList="items.categories"
                        @displayCart="displayCartVisible"
                        @calculateQtyCart="calculateQtyCart"
                        @hiddenCart="hiddenCart" @showCart="showCart"
                />
            </v-fade-transition>
        </v-main>
        <v-footer
                dark
                padless
        >
            <v-card
                    class="flex"
                    flat
                    tile
                    color="#06d6cf"
            >
                <v-card-title color="#06d6cf">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4" style="text-align: center">
                                <v-list dense color="#06d6cf">
                                    <v-list-item-group>
                                        <v-list-item :to="'/privacy-policy'">
                                            <v-list-item-content>
                                                <v-list-item-title>Privacy Policy</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item :to="'/account'">
                                            <v-list-item-content>
                                                <v-list-item-title>Orders</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div style="text-align: center">
                                    <img src="../assets/img/GoldSeal.gif" width="150" alt="">
                                </div>
                            </v-col>
                            <v-col cols="12" md="4" style="text-align: center">
                                <p>
                                    We are proud to have <br>
                                    The Joint Commission <br>
                                    Gold Seal of Approval
                                </p>

                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-title>

                <v-card-text class="py-2 white--text text-center">
                    <hr color="white">
                    {{ new Date().getFullYear() }} — <strong>PPS Healthcare</strong>
                </v-card-text>
            </v-card>
        </v-footer>
    </v-card>
</template>
<script>
    // Utilities
    import {
        mapMutations,
        mapState
    } from 'vuex'
    export default {
        metaInfo () {
            return {
                title: 'PPS Healthcare – Improving Your Lifestyle',
                meta: [
                    {description: 'PPS Healthcare – Improving Your Lifestyle'},
                    {keywords: 'PPS Healthcare – Improving Your Lifestyle'}
                ]
            }
        },
        data: () => ({
            appUrl:"https://api.ppshealthcare.com",
            cdnUrl:"https://cdn.ppshealthcare.com",
            searchBtn:false,
            term:'',
            cartVisible:0,
            showQtyCart:false,
            qtyCart:0,
            cartPage:false,
            search:false,
            drawer: false,
            items: {
                categories:{}
            },
            icons: [
                'mdi-facebook',
                'mdi-twitter',
                'mdi-instagram',
            ],
            cart:{
                total:0,
                address:{tax:0},
            },
            loading:{
                cart:false,
                search:false
            }
        }),
        computed: {
            ...mapState('app', ['image', 'color']),
            inputValue: {
                get () {
                    return this.$store.state.app.drawer
                },
                set (val) {
                    this.setDrawer(val)
                }
            }
        },
        methods: {
            getSearch(){
                if(this.term != ''){
                    if(this.term.length > 2){
                        document.getElementById('formSearch').click();
                    }
                }
            },
            displayCartVisible(event){
                if(event){
                    this.cartVisible ++;
                }
                this.loadCart();
            },
            hiddenCart(){
                this.cartPage = true;
            },
            showCart(){
                this.cartPage = false;
            },
            searchBar(){
                if(this.search){
                    this.search = false;
                }else{
                    this.search = true;
                }
            },
            init() {
                //token
                if (!(localStorage.token)) {
                    this.$http.get(this.appUrl+"/store/token").then(response =>{
                        localStorage.token = response.data.data;
                    });
                }
            },
            loadCart(){
                //cart
                var arr = {
                    token:localStorage.token
                };
                arr = JSON.stringify(arr);
                this.$http.post(this.appUrl+"/store/cart/get",arr).then(response => {
                    this.cart = response.data.data;
                    this.calculateQtyCart();
                });
            },
            loadPage(){
                //header
                this.$http.get(this.appUrl+"/store/header").then(response =>{
                    this.items = response.data;
                });
                this.loadCart();
            },
            calculateQtyCart(){
                this.qtyCart = 0;
                this.showQtyCart = false;
                if(this.cart.products.length){
                    for(var i = 0;i<this.cart.products.length;i++){
                        this.qtyCart = this.qtyCart+this.cart.products[i].qty;
                    }
                    this.showQtyCart = true;
                }
            },
            updateProductCart(item,condition){
                var qty = parseInt(this.cart.products[item].qty);
                if(qty <= 0){
                    qty = 1;
                }
                if(condition == 'manual'){
                    this.cart.products[item].qty = qty;
                }else if(condition == 'add'){
                    this.cart.products[item].qty = qty+1;
                }else{
                    if(qty <= 1){
                        this.cart.products[item].qty = 1;
                    }else{
                        this.cart.products[item].qty = qty-1;
                    }
                }
                var arr = {
                    token:localStorage.token,
                    id:this.cart.products[item].id_product,
                    qty:qty,
                    action:'update',
                };
                arr = JSON.stringify(arr);
                this.$http.post(this.appUrl+"/store/cart/add",arr).then(response => {
                    if(response){
                        this.calculateQtyCart();
                    }
                });
            },
            deleteProductCart(item){
                this.loading.cart = true;
                var arr = {
                    token:localStorage.token,
                    id:this.cart.products[item].id_product,
                };
                arr = JSON.stringify(arr);
                this.$http.post(this.appUrl+"/store/cart/delete",arr).then(response => {
                    this.loading.cart = false;
                    this.cart = response.data.data;
                    this.calculateQtyCart();
                });
            },
            currentPage(){
                var  page = window.location.pathname.split('/');
                if(page[1] == 'pt' || page[1] == 'es'){
                    if (typeof page[2] == 'undefined') {
                        page[2] = "";
                    }
                }else{
                    if (typeof page[1] == 'undefined') {
                        page[2] = "";
                    }else{
                        page[2] = page[1];
                    }
                }

                this.current.en = '/'+page[2];
                this.current.es = '/es/'+page[2];
                this.current.pt = '/pt/'+page[2];
//                console.log(this.current.en);
//                console.log(this.current.pt);
//                console.log(this.current.es);
            },
            ...mapMutations('app', ['setDrawer', 'toggleDrawer'])
        },
        mounted(){
            this.loadPage();
            this.init();
        },
        filters:{
            number_format_real(valor){
                return String(parseFloat(valor).toFixed(2));
            },
        },
        watch: {
            term:function (val) {
                if(val == ''){
                    this.searchBtn = false;
                }else{
                    this.searchBtn = true;
                }
            }
        }
    }
</script>